import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../redux/store'
import styles from './AddContractsModal.module.css'
import classNames from 'classnames'

import { useEffect, useState } from 'react'
import { useClearBodyNoScrollClass } from '../../../../hooks/use-clear-body-no-scroll-slass'
import {
  fetchAddContract,
  setIsVisibleModalContract,
} from '../../../../redux/reducers/documents/contracts'
import { fetchClients } from '../../../../redux/reducers/clients'
import { clientsSelector } from '../../../../redux/selectors/clients-selector'
import { onlyNumberRegularCheck } from '../../../../utils/onlyNumberRegularCheck'
import { contractsSelector } from '../../../../redux/selectors/documents/contracts-selector'
import { default as Select } from 'react-select'
import {
  getAmount,
  getContractRemainingAmount,
  getItemCurrency,
} from '../../../../utils/getAmount'
import CurrencyRadioGroup from '../../../common/currency-radio/CurrencyRadioGroup'
import { isLessThanAMonth, formatDate } from '../../../../utils/date'

interface ClientOption {
  value: number
  label: string
}
const STATUS = [
  {
    name: 'Активен',
    value: true,
  },
  {
    name: 'Закрыт',
    value: false,
  },
]
const getAmountPercent = (item: any) => {
  // Проверяем, есть ли необходимые данные
  if (!item.amount || !item.paid_invoices) {
    return false
  }

  // Вычисляем процент оплаченных счетов от общей суммы
  const percentage = (item.paid_invoices / item.amount) * 100

  // Возвращаем true, если оплачено больше 80%
  return percentage > 80
}

const getDaysUntilExpiration = (expiresAt: string): number => {
  const targetDate = new Date(expiresAt)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  targetDate.setHours(0, 0, 0, 0)

  const diffInMs = targetDate.getTime() - today.getTime()
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))

  return diffInDays
}

const isContractExpired = (expiresAt: string): boolean => {
  const targetDate = new Date(expiresAt)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  targetDate.setHours(0, 0, 0, 0)

  return targetDate.getTime() < today.getTime()
}
function AddContractsModal() {
  const dispatch = useDispatch<AppDispatch>()
  const { currentContract } = useSelector(contractsSelector)
  const { clients } = useSelector(clientsSelector)
  useClearBodyNoScrollClass()

  useEffect(() => {
    dispatch(fetchClients())
  }, [])

  const [clientId, setClientId] = useState('')
  const [date, setDate] = useState('')
  const [expiresAt, setExpiresAt] = useState('')
  const [number, setNumber] = useState('')
  const [amount, setAmount] = useState('')

  const [currency, setCurrency] = useState('BYN')
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (currentContract) {
      const {
        date,
        active,
        expires_at,
        number,
        client: { id },
        amount,
        currency,
      } = currentContract
      setClientId(String(id))
      setDate(date)
      setExpiresAt(expires_at)
      setNumber(number)
      setAmount(amount)
      setCurrency(currency)
      setIsActive(active)
    }
  }, [])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setCurrency(value)
  }

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value === 'true'
    setIsActive(selectedValue)
    setErrors((prevErrors) => ({ ...prevErrors, isActive: false }))
  }

  const handleSelectChangeClient = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedId = event.target.value
    setClientId(selectedId)
    setErrors((prevErrors) => ({ ...prevErrors, clientId: false }))
  }

  const handleReactSelectChange = (selectedOption: ClientOption | null) => {
    // Эмулируем событие, которое ожидает ваш handleSelectChangeClient
    const fakeEvent = {
      target: {
        value: selectedOption ? selectedOption.value : '',
        name: 'clientId', // или другое имя поля, если нужно
      },
    } as React.ChangeEvent<HTMLSelectElement>

    // Вызываем оригинальный обработчик
    handleSelectChangeClient(fakeEvent)
  }

  const [errors, setErrors] = useState({
    clientId: false,
    isActive: false,
    date: false,
    expiresAt: false,
    number: false,
  })

  const checkValidation = () => {
    const newErrors = {
      clientId: !clientId,
      isActive: !isActive,
      date: !date,
      expiresAt: !expiresAt,
      number: !number,
    }

    setErrors(newErrors)
  }

  const handleSaveButtonClick = () => {
    const newErrors = {
      clientId: !clientId,
      isActive: isActive === null || isActive === undefined,
      date: !date,
      expiresAt: !expiresAt,
      number: !number,
    }

    setErrors(newErrors)

    const hasErrors = Object.values(newErrors).some((error) => error)

    if (!hasErrors) {
      dispatch(
        fetchAddContract({
          id: currentContract?.id,
          isActive,
          clientId,
          date,
          expiresAt,
          number,
          currency,
          amount,
        })
      )
    }
  }

  // Вычисляем данные для уведомления об истечении срока договора
  const hasExpirationDate = currentContract && currentContract.expires_at
  const isExpired =
    hasExpirationDate && isContractExpired(currentContract.expires_at)
  const isExpiringSoon =
    hasExpirationDate &&
    !isExpired &&
    isLessThanAMonth(currentContract.expires_at)
  const shouldShowNotification = isExpired || isExpiringSoon

  const daysUntilExpiration =
    shouldShowNotification && currentContract?.expires_at
      ? getDaysUntilExpiration(currentContract.expires_at)
      : 0

  const clientName =
    shouldShowNotification && currentContract
      ? (currentContract.client as any)?.entity_name ||
        currentContract.client?.name ||
        'клиентом'
      : ''

  const daysText =
    Math.abs(daysUntilExpiration) === 1
      ? 'день'
      : Math.abs(daysUntilExpiration) < 5
        ? 'дня'
        : 'дн.'

  return (
    <div
      style={{ display: 'block' }}
      className={styles.win}
      id="win_company_edit"
    >
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div
            onClick={() => dispatch(setIsVisibleModalContract(false))}
            className={styles.close}
          >
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <h3
              style={{ textAlign: 'center' }}
              className={classNames(styles.h3, 'mb-2')}
            >
              {currentContract ? 'Редактировать договор' : 'Добавить договор'}
            </h3>

            {shouldShowNotification && currentContract?.expires_at && (
              <div
                className={classNames(styles.colorRed, styles.small)}
                style={{ textAlign: 'center' }}
              >
                <br />
                {isExpired ? (
                  <>
                    Истёк срок договора с "{clientName}".{' '}
                    {formatDate(currentContract.expires_at)}
                  </>
                ) : (
                  <>
                    Истекает срок договора с "{clientName}". Через{' '}
                    {daysUntilExpiration} {daysText},{' '}
                    {formatDate(currentContract.expires_at)}
                  </>
                )}
              </div>
            )}

            {!(currentContract && getAmountPercent(currentContract)) && <br />}

            {currentContract && getAmountPercent(currentContract) && (
              <div
                className={classNames(styles.colorRed, styles.small, 'mb-3')}
                style={{ textAlign: 'center' }}
              >
                <br />
                Близок предел суммы договора{' '}
                {getAmount(currentContract.paid_invoices)} из{' '}
                {getAmount(currentContract.amount)}{' '}
                {getItemCurrency(currentContract.currency)}
                <br />
                Осталось:{' '}
                {getAmount(
                  getContractRemainingAmount(
                    currentContract.amount,
                    currentContract.paid_invoices
                  )
                )}{' '}
                {getItemCurrency(currentContract.currency)}
              </div>
            )}

            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row mb-3">
                <div className="col-12 col-sm-8 col-xl-8 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Клиент
                  </small>
                  <Select<ClientOption>
                    options={[...clients]
                      .sort((a, b) => {
                        const nameA = (a.entity_name || a.name).toLowerCase() // Приводим к нижнему регистру
                        const nameB = (b.entity_name || b.name).toLowerCase()
                        return nameA.localeCompare(nameB, 'ru') // Указываем локаль для правильной сортировки русских букв
                      })
                      .map((item) => ({
                        value: item.id,
                        label: item.entity_name || item.name,
                      }))}
                    value={
                      clients
                        .filter((item) => String(item.id) === clientId)
                        .map((item) => ({
                          value: item.id,
                          label: item.entity_name || item.name,
                        }))[0]
                    }
                    onChange={handleReactSelectChange}
                    placeholder="Выберите клиента"
                    noOptionsMessage={() => 'Клиент не найден'}
                    className={errors.clientId ? styles.isError : ''}
                    styles={{
                      control: (base, { isFocused }) => ({
                        ...base,
                        minHeight: '38px',
                        height: '38px',
                        borderColor: errors.clientId
                          ? 'red'
                          : isFocused
                            ? '#0a4475'
                            : '#ccc',
                        boxShadow: isFocused
                          ? 'inset 1px 3px 5px 0px #0000001c;, 0 0 0 1px #0a4475'
                          : 'inset 1px 3px 5px 0px #0000001c;',
                        '&:hover': {
                          borderColor: errors.clientId ? 'red' : '#0a4475',
                        },
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: '38px',
                        padding: '0 6px',
                      }),
                      input: (base) => ({
                        ...base,
                        margin: '0px',
                        padding: '0px',
                        color: '#333',
                        '& input': {
                          height: '38px',
                          boxShadow: 'none !important',
                          border: 'none !important',
                        },
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        height: '38px',
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: '4px',
                      }),
                      clearIndicator: (base) => ({
                        ...base,
                        padding: '4px',
                      }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected
                          ? '#0a4475'
                          : isFocused
                            ? '#F0F0F0'
                            : 'white',
                        color: isSelected ? 'white' : '#333',
                        padding: '8px 12px',
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: 4,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      }),
                      singleValue: (base) => ({
                        ...base,
                        lineHeight: '1.2',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        lineHeight: '1.2',
                      }),
                    }}
                  />
                </div>

                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Статус
                  </small>

                  <select
                    onChange={handleSelectChange}
                    value={String(isActive)}
                    className={errors.isActive ? styles.isError : ''}
                  >
                    {STATUS.map((item) => (
                      <option key={item.name} value={String(item.value)}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Номер
                  </small>
                  <input
                    className={errors.number ? styles.isError : ''}
                    value={number}
                    onChange={(e) => {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        number: false,
                      }))

                      setNumber(e.target.value)
                    }}
                    required
                    type="text"
                    placeholder="Номер договора"
                  />
                </div>

                <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Дата
                  </small>
                  <div className="calendar" id="calendar_contract_date">
                    <input
                      // min={insuranceEndRb || undefined}
                      className={classNames(
                        styles.calendarInput,
                        styles.date,
                        errors.date ? styles.isError : ''
                      )}
                      type="date"
                      value={date}
                      onChange={(e) => {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          date: false,
                        }))
                        setDate(e.target.value)
                      }}
                      pattern="\d{4}-\d{2}-\d{2}"
                    />
                  </div>
                </div>

                <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Действует до
                  </small>
                  <div className="calendar" id="calendar_contract_date_to">
                    <input
                      // min={insuranceEndRb || undefined}
                      className={classNames(
                        styles.calendarInput,
                        styles.date,
                        errors.date ? styles.isError : ''
                      )}
                      type="date"
                      value={expiresAt}
                      onChange={(e) => {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          expiresAt: false,
                        }))

                        setExpiresAt(e.target.value)
                      }}
                      pattern="\d{4}-\d{2}-\d{2}"
                    />
                  </div>
                </div>

                <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3">
                  <small className={classNames(styles.small2, 'd-block mb-1')}>
                    Сумма договора
                  </small>
                  <input
                    value={amount}
                    onChange={(e) => {
                      if (onlyNumberRegularCheck(e)) {
                        setAmount(e.target.value.replace(',', '.'))
                      }
                    }}
                    type="text"
                    placeholder="Сумма договора"
                  />
                  <CurrencyRadioGroup
                    value={currency || 'BYN'}
                    onChange={handleInputChange}
                    wrapperClassName={styles.small2}
                    labelClassName="ml-1 mr-0"
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'left' }}
                >
                  <button
                    onClick={handleSaveButtonClick}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn
                    )}
                  >
                    <i className={`${styles.icon} ${styles.iconCheckWhite}`} />{' '}
                    {!currentContract ? 'Создать' : 'Сохранить'}
                  </button>
                </div>
                <div
                  className="col-12 col-sm-6 mt-1 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  <div
                    onClick={() => dispatch(setIsVisibleModalContract(false))}
                    className={classNames(
                      'd-block',
                      'd-sm-inline-block',
                      styles.btn,
                      styles.btnSmall,
                      styles.btnBlueOutline
                    )}
                  >
                    Отмена
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddContractsModal
